import jwtService from "app/services/jwtService";
import Axios from "axios";
import SignupService from "../../../services/signupService/index";
import * as UserActions from "./user.actions";

export const REGISTER_ERROR = "REGISTER_ERROR";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_STATES = "GET_STATES";
export const GET_CITIES = "GET_CITIES";

export function submitRegister({ displayName, password, email }) {
	return (dispatch) =>
		jwtService
			.createUser({
				displayName,
				password,
				email,
			})
			.then((user) => {
				dispatch(UserActions.setUserData(user));
				return dispatch({
					type: REGISTER_SUCCESS,
				});
			})
			.catch((error) => {
				return dispatch({
					type: REGISTER_ERROR,
					payload: error,
				});
			});
}

export function submitOwnerSignup(data) {
	return (dispatch) =>
		SignupService.ownerSignup(data)
			.then((user) => {
				localStorage.setItem("userData", JSON.stringify(user));
				dispatch(UserActions.setUserData(user));
				return dispatch({
					type: REGISTER_SUCCESS,
				});
			})
			.catch((error) => {
				return dispatch({
					type: REGISTER_ERROR,
					payload: error,
				});
			});
}

export function getCountries() {
	let baseUrl = process.env.REACT_APP_API_KEY;

	const request = Axios.get(baseUrl + "countries", {
		headers: {
			Authorization: "Bearer " + localStorage.getItem("access_token"),
		},
	});

	return (dispatch) =>
		request
			.then((response) =>
				dispatch({
					type: GET_COUNTRIES,
					payload: response.data.data,
				})
			)
			.catch((error) => {
				if (
					error.response &&
					error.response.data &&
					error.response.data.message &&
					error.response.data.message === "Invalid Auth Token"
				) {
					console.log("invalid token or user");
				}
			});
}
export function getStates(countryId) {
	let baseUrl = process.env.REACT_APP_API_KEY;
	const request = Axios.get(baseUrl + `states/${countryId && countryId.name}`, {
		headers: {
			Authorization: "Bearer " + localStorage.getItem("access_token"),
		},
	});

	return (dispatch) =>
		request
			.then((response) =>
				dispatch({
					type: GET_STATES,
					payload: response.data.data,
				})
			)
			.catch((error) => {
				if (
					error.response &&
					error.response.data &&
					error.response.data.message &&
					error.response.data.message === "Invalid Auth Token"
				) {
					console.log("invalid token or user");
				}
			});
}
export function getCities(stateId) {
	let baseUrl = process.env.REACT_APP_API_KEY;

	const request = Axios.get(baseUrl + `cities/${stateId.name}`, {
		headers: {
			Authorization: "Bearer " + localStorage.getItem("access_token"),
		},
	});

	return (dispatch) =>
		request
			.then((response) =>
				dispatch({
					type: GET_CITIES,
					payload: response.data.data,
				})
			)
			.catch((error) => {
				if (
					error.response &&
					error.response.data &&
					error.response.data.message &&
					error.response.data.message === "Invalid Auth Token"
				) {
					console.log("invalid token or user");
				}
			});
}
